module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/line-icon-a65259ff1332bd990da73fd5fb15e026.svg&quot;;"